import React, { useEffect, useState } from 'react';
import { FiExternalLink, FiX } from 'react-icons/fi';
import { Link, useNavigate } from 'react-router-dom';
import apiService from '../../services/api';
import SafeMessageHtml from './SafeMessageHtml';
import GraduationInviteBanner from '../../pages/student/messages/GraduationInviteBanner';
import { GRADUATION_INVITE_TITLE } from '../../pages/student/messages/graduationInviteContent';
import styles from './StudentDashboardMessages.module.css';

function isExternalUrl(url) {
  return /^https?:\/\//i.test(url || '');
}

export default function StudentDashboardMessages() {
  const navigate = useNavigate();
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await apiService.getActiveStudentMessages();
        if (cancelled) return;
        if (res?.landing) {
          navigate(`/student/messages/${res.landing.id}`, { replace: true });
          return;
        }
        setBanners(res?.banners || []);
      } catch (error) {
        if (!cancelled) setBanners([]);
      }
    })();
    return () => { cancelled = true; };
  }, [navigate]);

  const dismiss = async (id) => {
    setBanners((current) => current.filter((banner) => banner.id !== id));
    await apiService.dismissStudentMessage(id).catch(() => {});
  };

  if (banners.length === 0) return null;

  return (
    <div className={styles.stack}>
      {banners.map((message) => (
        message.title === GRADUATION_INVITE_TITLE ? (
          <GraduationInviteBanner key={message.id} message={message} />
        ) : (
        <section key={message.id} className={`${styles.banner} ${styles[message.animationType] || ''}`}>
          <div className={styles.content}>
            <p className={styles.label}>Message</p>
            <h2 className={styles.title}>{message.title}</h2>
            <SafeMessageHtml html={message.bodyHtml} className={styles.body} />
            {message.ctaUrl && message.ctaLabel && (
              isExternalUrl(message.ctaUrl) ? (
                <a className={styles.link} href={message.ctaUrl} target="_blank" rel="noreferrer">
                  {message.ctaLabel}
                  <FiExternalLink size={14} />
                </a>
              ) : (
                <Link className={styles.link} to={message.ctaUrl}>{message.ctaLabel}</Link>
              )
            )}
          </div>
          {message.dismissBehavior !== 'never' && (
            <button className={styles.dismiss} onClick={() => dismiss(message.id)} aria-label="Dismiss message">
              <FiX size={16} />
            </button>
          )}
        </section>
        )
      ))}
    </div>
  );
}
